<template>
  <v-container fluid class="background-white fill-height">
    <v-row class="no-gutters flex-wrap flex-column fill-height">
      <v-col cols="auto">
        <campaign-image :imageUrl="campaign.logo" />
        <v-sheet>
          <div class="pa-4 px-8 text-center text-body-2">
            {{ campaign.description }}
            <div v-if="campaign.rules_uploaded" class="my-4">
              <a target="_blank" :href="rulesUrl">Scarica il regolamento</a>
            </div>
          </div>
          <div class="text-center text-h5 primary--text py-4">
            Scegli chi sostenere
          </div>
          <v-text-field
            class="mx-auto"
            style="max-width: 80%"
            v-model="searchClient"
            solo
            placeholder="Cerca"
            dense
            light
          >
            <v-icon slot="append">mdi-magnify</v-icon>
          </v-text-field>
        </v-sheet>
      </v-col>
      <v-col
        cols="auto"
        class="grow gray mb-8"
        v-if="campaign.sorting_type === 1"
      >
        <npo-card
          v-for="(npo, index) in filteredNpos"
          :key="index"
          :npo="npo"
          @go-to-npo="goToNpo(npo)"
        />
      </v-col>
      <v-col
        cols="auto"
        class="grow gray mb-8"
        v-if="campaign.sorting_type === 2"
      >
        <template v-for="(area, index) in npos.data">
          <v-list-item-title
            class="primary--text text-center text-h5"
            :key="index"
          >
            {{ area.name | capitalize }}
          </v-list-item-title>

          <v-list :key="index">
            <v-divider :key="index" inset></v-divider>
            <template v-for="(npo, i) in filteredNpos3(index)">
              <npo-row :key="i" :npo="npo" @go-to-npo="goToNpo(npo)" />
              <v-divider :key="i" inset></v-divider>
            </template>
            <div class="mb-4"></div>
          </v-list>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiService from '@/services'
import npoCard from './QrcodeNpoCard'
import npoRow from './QrcodeNpoRow'
import campaignImage from '@/components/qrcode-vote-components/BaseHeaderImage'

export default {
  components: {
    'npo-card': npoCard,
    'campaign-image': campaignImage,
    'npo-row': npoRow
  },
  data () {
    return {
      imageUrl: '@/assets/the_good_company_logo.jpg',
      searchClient: '',
      isActive: false,
      campaign: {},
      dataLoading: true,
      npos: {
        data: [],
        total: 0
      }
    }
  },

  computed: {
    rulesUrl () {
      return `${process.env.VUE_APP_BASE_URL}/campaigns/${this.campaign.campaign}/download/rules`
    },
    filteredNpos () {
      const filter = this.searchClient.toLowerCase().trim()
      console.log(filter)
      if (!filter) return this.npos.data
      var tmpNpo = this.npos.data.filter(
        (npo) => npo.name.toLowerCase().indexOf(filter) > -1
      )
      console.log('TMP_NPO', tmpNpo)

      return tmpNpo
    }
  },

  created () {
    // Check if campaign is leading
    if (this.$route.params.campaignId) {
      sessionStorage.setItem('campaign_id', this.$route.params.campaignId)
    }

    if (this.$route.params.leadId) {
      sessionStorage.setItem('lead_id', this.$route.params.leadId)
    }

    if (this.$route.params.token) {
      sessionStorage.setItem('qrcodeToken', this.$route.params.token)
    }

    if (this.$route.params.isLeading) {
      sessionStorage.setItem('isLeading', this.$route.params.isLeading)
    }

    if (this.$route.params.logo) {
      sessionStorage.setItem('logo', this.$route.params.logo)
    }
    this.campaign = JSON.parse(sessionStorage.getItem('campaign'))
    this.$vuetify.theme.themes.light.primary = this.campaign.primary_color
    this.$vuetify.theme.themes.light.secondary = this.campaign.secondary_color
    this.getCampaignNpos(sessionStorage.getItem('campaign_id'))
    this.campaign.skipConfig = true
  },

  methods: {
    filteredElem (filterValue) {
      var data = this.filteredNpos.filter(npo => npo.area[0].name === filterValue)
      console.log(data)
      return data
    },
    filteredNpos3 (index) {
      const searchFilter = this.searchClient.toLowerCase().trim()
      if (!searchFilter) return this.npos.data[index].npos

      return this.npos.data[index].npos.filter((npo) => {
        return npo.name.toLowerCase().indexOf(searchFilter) > -1
      })
    },
    // GET Npos
    getCampaignNpos (campaignId) {
      console.log('NNNNNNNN', this.campaign)
      this.campaign.sorting_type = 1
      if (this.campaign.sorting_type === 2) {
        apiService
          .getQrcodeGroupedNpos(campaignId)
          .then((response) => {
            this.npos.data = response.data
            this.npos.total = response.data.length
            this.dataLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        apiService
          .getQrcodeVoteNpos(campaignId)
          .then((response) => {
            this.npos.data = response.data
            this.npos.total = response.data.length
            this.dataLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },

    goToNpo (npo) {
      let params = {
        npoId: npo.id,
        logo: npo.logo,
        npo: npo,
        title: 'Hai scelto',
        leadId: sessionStorage.getItem('lead_id'),
        token: sessionStorage.getItem('qrcodeToken')
      }
      if (this.campaign.skipConfig && !this.isLeading) {
        params.skipConfig = true
      }
      this.$router.push({
        name: 'qrcodenpo',
        params: params
      })
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
